import React from "react";
import PropTypes from "prop-types";
import { CustomButton } from "./ButtonStyles.js";

const Button = ({ type, label, clickHandler, className }) => {
  return (
    <CustomButton
      className={className}
      as="button"
      onClick={clickHandler}
      type={type}
    >
      {label}
    </CustomButton>
  );
};

Button.propTypes = {
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  clickHandler: PropTypes.func.isRequired,
  className: PropTypes.string,
};
Button.defaultProps = {
  type: "primary",
  label: "test button",
  clickHandler: () => {
    return true;
  },
};

export default Button;
